<template lang="html">
  <div class="col-lg-9 col-page-content page-comments">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 mb-0 box-acc-title-s1">
              <h4>Calificaciones a empresas</h4>
              <hr />
            </div>

            <div class="col-12 box-average-rating">
              

              
            </div>

          </div>
        </div>

        <div class="mt-2 px-0 box-empty-bubble box-comments" v-if="$root.user.calficationstocompanies.length == 0">
              <p>Aun no tienes calificaciones</p>
        </div>
        
        <div class="mt-2 px-0 box-empty-bubble box-comments">

          <div class="box-comment-sample-s1" v-for="(calification, indxc) in $root.user.calficationstocompanies" :key="indxc">
            <div class="col col-photo">
              <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+calification.empresa_imageUrl+')' }"></div>
            </div>

            <div class="col col-info">
              <div class="box-date">{{calification.fecha}}</div>
              <h4>{{calification.empresa}}</h4>

              <div class="box-stars">
                <i class="fas fa-star star" v-for="(star, indst) in calification.calificacion" :key="indst"></i>
              </div>

              <div class="box-descr">{{calification.msg}}</div>

              <!-- <div class="box-buttons">
                <a class="btn btn-cur-1 bg-red sm mr-sm-1">Borrar comentario</a>
                <a class="btn btn-cur-1 sm" @click="addResponse">Responder</a>
              </div> -->
            </div>
          </div>

        </div>

      </div>

    </div>

    <!-- Modal - Responder -->
    <b-modal ref="modal-response" hide-footer no-close-on-backdrop no-close-on-esc centered size="lg" modal-class="modal-comment__user-account" title="Responder comentario">
      <div class="box-comment">
        <div class="box-comment-sample-s1">
          <div class="col col-photo">
            <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url(public/images/pages/users/profile-4.jpg)' }"></div>
          </div>

          <div class="col col-info">
            <div class="box-date">4 de Octubre</div>
            <h4>Richard</h4>

            <div class="box-stars">
              <i class="fas fa-star star"></i>
              <i class="fas fa-star star"></i>
            </div>

            <div class="box-descr">
              Pesima empresa Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minition ullamco laboris nisi ut aliquip ex ea  velit esse cillum dolore eu fugiat nulla pariatur, excepteur sint.
            </div>
          </div>
        </div>
      </div>

      <div class="box-response">
        <b-form-group>
          <b-form-textarea
            v-model="form.msg"
            placeholder="Tu respuesta como empresa"
            rows="4"
            max-rows="4"
            required
          ></b-form-textarea>
        </b-form-group>

        <div class="box-buttons">
          <b-button type="submit" class="btn-squ-cur-1 lg blue">Responder comentario</b-button>
        </div>
      </div>
    </b-modal>
    <!--  -->

  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        msg: null,
      }
    }
  },

  methods: {
    addResponse(){
      this.$refs['modal-response'].show();
    }
  },

  mounted(){
  }
}
</script>
